import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/database'

type SupabaseDatabase = {
  public: {
    Tables: {
      [TableName in keyof Database['public']['Tables']]:
      Database['public']['Tables'][TableName] & {
        Relationships: []
      }
    }
    Views: Record<string, never>
    Functions: {
      read_published_paper: {
        Args: { publication_id: string }
        Returns: { title: string; body: string; published_at: string; updated_at: string }[]
      }
      delete_user_account: {
        Args: Record<PropertyKey, never>
        Returns: undefined
      }
      upsert_daily_sets_delta: {
        Args: {
          p_area_id: string
          p_set_date: string
          p_word_delta: number
        }
        Returns: Database['public']['Tables']['daily_sets']['Row']
      }
      search_documents_rpc: {
        Args: {
          p_query: string
          p_entity_types?: string[] | null
          p_area_id?: string | null
          p_include_completed?: boolean
          p_include_drafts?: boolean
          p_include_templates?: boolean
          p_limit?: number
          p_offset?: number
        }
        Returns: {
          entity_type: 'paper' | 'area' | 'stack'
          entity_id: string
          area_id: string | null
          paper_id: string | null
          title: string
          snippet: string
          rank: number
          is_completed: boolean | null
          is_draft: boolean | null
          is_template: boolean | null
        }[]
      }
    }
    Enums: Record<string, never>
    CompositeTypes: Record<string, never>
  }
}

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient<SupabaseDatabase>(supabaseUrl, supabaseAnonKey)
